import { atomWithThunksReducer } from "utilities/atoms/atom-with-thunks-reducer";
import {
    ConversationHistoryAction,
    ConversationHistoryState,
    conversationHistoryReducer,
} from "./conversation-history-atom-reducer";
import { getSavedState } from "../conversations.persistence";

export const ConversationHistoryAtom = atomWithThunksReducer<
    ConversationHistoryState,
    ConversationHistoryAction
>(
    getSavedState(
        "conversationHistory",
        conversationHistoryReducer.defaultState
    ),
    conversationHistoryReducer
);
